export function pluralize(count: number, singular: string): string {
  return count === 1 ? `1 ${singular}` : `${count} ${singular}s`;
}

export function formatPrice(amount: number, currency: string, locale = "en"): string {
  if (!Number.isFinite(amount) || amount < 0) return "";
  try {
    const options: Intl.NumberFormatOptions = { style: "currency", currency };
    if (Number.isInteger(amount)) options.maximumFractionDigits = 0;
    return new Intl.NumberFormat(locale, options).format(amount);
  } catch {
    return "";
  }
}
